import { useState } from 'react';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza.tsx';
import { CreateNotificationRuleForm } from '@/features/notification-rules/components/create-notification-rule/create-notification-rule-form.tsx';

export function NotificationRulesTableRowActionDuplicateDialog({
  notificationRule,
}: {
  notificationRule: NotificationRule;
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onClose = () => setIsDialogOpen(false);

  return (
    <Credenza open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <CredenzaTrigger asChild>
        <button className="focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none hover:bg-gray-100 data-disabled:pointer-events-none data-disabled:opacity-50">
          <span>Duplicate</span>
        </button>
      </CredenzaTrigger>
      <CredenzaContent className="max-w-2xl">
        <CredenzaHeader>
          <CredenzaTitle>Duplicate: {notificationRule.notificationTitle}</CredenzaTitle>
          <CredenzaDescription>
            Create a new rule based on the existing configuration
          </CredenzaDescription>
        </CredenzaHeader>
        <CredenzaBody className="pb-4">
          <CreateNotificationRuleForm
            onClose={onClose}
            initialValues={{
              notificationTitle: `${notificationRule.notificationTitle} (copy)`,
              ruleType: notificationRule.ruleType,
              plantId: notificationRule.plantId,
              deviceType: notificationRule.deviceType,
              deviceId: notificationRule.deviceId,
              deviceSN: notificationRule.deviceSN,
              conditions: notificationRule.conditions,
              notificationTemplate: notificationRule.notificationTemplate,
              notificationPreviewTemplate: notificationRule.notificationPreviewTemplate,
              cooldownPeriod: notificationRule.cooldownPeriod,
              status: notificationRule.status,
              managedBy: notificationRule.managedBy,
            }}
          />
        </CredenzaBody>
      </CredenzaContent>
    </Credenza>
  );
}
